import { render, staticRenderFns } from "./DataManagementPage.vue?vue&type=template&id=565c2366&scoped=true"
import script from "./DataManagementPage.vue?vue&type=script&lang=js"
export * from "./DataManagementPage.vue?vue&type=script&lang=js"
import style0 from "./DataManagementPage.vue?vue&type=style&index=0&id=565c2366&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565c2366",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('565c2366')) {
      api.createRecord('565c2366', component.options)
    } else {
      api.reload('565c2366', component.options)
    }
    module.hot.accept("./DataManagementPage.vue?vue&type=template&id=565c2366&scoped=true", function () {
      api.rerender('565c2366', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/DataManagementPage.vue"
export default component.exports